import { render, staticRenderFns } from "./page1.vue?vue&type=template&id=36a4328c&scoped=true"
import script from "./page1.vue?vue&type=script&lang=js"
export * from "./page1.vue?vue&type=script&lang=js"
import style0 from "./page1.vue?vue&type=style&index=0&id=36a4328c&prod&lang=less&rel=stylesheet%2Fless&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a4328c",
  null
  
)

export default component.exports